const DashboardEndpoints = {
  overview: "index",
  plans: "plans",
  posts: "posts",
  outreach: "outreach",
  stats: "stats",
};

export default DashboardEndpoints;
